<template>
    <v-dialog v-model="dialog" persistent max-width="400">
        <v-card class="d-flex flex-column justify-center align-center border-radius-1">
            <div
                class="d-flex flex-column justify-center align-center position-relative pa-6"
            >
                <!-- <div class="p-img d-flex flex-column justify-center align-center"> -->
                <div>
                    <img :src="usedImg" width="100" height="100" alt="pistas imagen de modal" />
                </div>
                <div class="py-3 d-flex flex-column justify-center align-center">
                    <span class="text-h6 white--text font-weight-bold">{{
                        $t('bookReading.wildcard_used_msg')
                    }}</span>
                </div>
            </div>
        </v-card>
    </v-dialog>
</template>
<script>
/* eslint-disable global-require */

export default {
    props: {
        dialog: { type: Boolean, default: false },
    },
    data() {
        return {
            usedImg: require('@/assets/img/gamifications/hand.png'),
        }
    },
    methods: {
        close() {
            this.$emit('close-modal')
        },
    },
}
</script>
<style>
.p-img {
    z-index: 300;
}
.p-img img {
    height: 20vh;
    z-index: 10;
}
.pistas-content {
    border-radius: 26px;
    background: linear-gradient(180deg, #6f5fa4 0%, #261c48 100%);
}
.items-unset {
    align-items: unset !important;
}
</style>
